import React from 'react';
import { Icon } from './Icon.js';
export const IconArrowDownRight = ({ ...props }) => {
    return (React.createElement(Icon, { size: "20px", ...props },
        React.createElement("line", { x1: "4", y1: "4", x2: "16", y2: "16", fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2", "data-color": "color-2" }),
        React.createElement("polyline", { points: "16 9 16 16 9 16", fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2" })));
};
//# sourceMappingURL=IconArrowDownRight.js.map